// extracted by mini-css-extract-plugin
module.exports = {"manufacturer":"styles_manufacturer__h1N2P","header":"styles_header__2zi4S","add":"styles_add__1DR69"};